import { render, staticRenderFns } from "./LicenseSlide.vue?vue&type=template&id=276a0552&scoped=true"
import script from "./LicenseSlide.vue?vue&type=script&lang=js"
export * from "./LicenseSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a0552",
  null
  
)

export default component.exports